<template>
  <div class="users pa-2">
    <DxDataGrid
        v-if="hasPermission('users.view')"
        :ref="gridRefName"
        :allow-column-reordering="true"
        :data-source="users"
        
        :column-auto-width="true"
        :row-alternation-enabled="true"
        :show-row-lines="true"
        @init-new-row="onInitNewRow"
        @editing-start="onEditingStart"
        @editor-preparing="onEditorPreparing"
    >
      <DxColumnFixing :enabled="true" />
      <DxEditing
          :allow-updating="hasPermission('users.update')"
          :allow-deleting="hasPermission('users.delete')"
          :allow-adding="hasPermission('users.add')"
          mode="popup"
      >
        <DxDataGridEditPopup
            id="popup"
            :show-title="true"
            :drag-enabled="false"
            title-template="getTitle"
        >
        </DxDataGridEditPopup>
        <DxDatagridEditForm :customize-item="customizeItem">
          <DxFormItem :col-count="2" :col-span="2" item-type="group">
            <DxFormItem :col-span="2" data-field="id" />
            <DxFormItem caption="Email cím"
                        data-field="email" />
            <DxFormItem caption="Felhasználónév"
                        data-field="userName" />
            <DxFormItem caption="Teljes név"
                        data-field="fullName" />
            <DxFormItem caption="Telefonszám"
                        data-field="phoneNumber" />
          </DxFormItem>
          <!-- TODO A permission vizsgálatokat tesztelni kell, valószínűleg több helyen kell vizsgálni -->
          <DxFormItem
              v-if="hasPermission('roles.view')"
              :col-count="2"
              :col-span="2"
              item-type="group"
          >
            <DxFormItem
                :col-span="2"
                data-field="roles"
                editor-type="dxTagBox"
                :editor-options="{
                dataSource: rolesLookup,
                valueExpr: 'name',
                displayExpr: 'description'
              }"
            />
          </DxFormItem>
          <DxFormItem :col-span="2" itemType="empty"></DxFormItem>
          <DxFormItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              name="changePasswordButton"
          >
            <DxButtonItem
                :col-span="2"
                :button-options="changePasswordButtonOptions"
                horizontal-alignment="left"
            ></DxButtonItem>
          </DxFormItem>
          <DxFormItem :col-count="2" :col-span="2" item-type="group">
            <DxFormItem caption="Jelszó"
                data-field="newPassword"
                :editorOptions="{ mode: 'password' }"
            />
            <DxFormItem :col-span="2" itemType="empty"></DxFormItem>
            <DxFormItem
                        caption="Jelszó megerősítés"
                data-field="confirmPassword"
                :editorOptions="{ mode: 'password' }"
            />
          </DxFormItem>
        </DxDatagridEditForm>
      </DxEditing>
      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="true" />
      <DxPaging />
      <DxSearchPanel :visible="true" />
      <DxColumn data-field="id" :visible="false" :allowEditing="false" />
      <DxColumn caption="Felhasználónév" data-field="userName" :fixed="true">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn caption="Email cím" data-field="email">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn caption="Jelszó" data-field="newPassword" data-type="password" :visible="false">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn caption="Jelszó megerősítés"
          data-field="confirmPassword"
          data-type="password"
          :visible="false"
      >
        <DxRequiredRule />
      </DxColumn>
      <DxColumn caption="Teljes név" data-field="fullName" />

      <DxColumn caption="Telefonszám" data-field="phoneNumber" />
      <DxColumn caption="Szerepkörök"
          v-if="hasPermission('roles.view')"
          data-field="roles"
          cell-template="rolesCellTemplate"
          width="200"
      >
      </DxColumn>
      <template #rolesCellTemplate="cell">
        <DxTagBox
            :readOnly="true"
            :dataSource="rolesLookup"
            :value="cell.data.value"
            valueExpr="name"
            displayExpr="description"
            tag-template="tagTemplate"
        >
          <template #tagTemplate="item">
            <div class="dx-tag-content" style="padding: 3px 6px 4px 2px;">
              {{ item.data.description }}
            </div>
          </template>
        </DxTagBox>
      </template>
      <DxColumn caption="Kizárva" data-field="isLockedOut" />
      <DxColumn caption="Engedélyezve" data-field="isEnabled" />
      <template #getTitle>
        <DxToolbar>
          <DxToolbarItem #default location="center">
            <div class="toolbar-label">
              <b>{{ isNewRow ? "New User" : "Edit User" }}</b>
            </div>
          </DxToolbarItem>

          <DxToolbarItem
              :options="closeButtonOptions"
              location="after"
              widget="dxButton"
          />
        </DxToolbar>
      </template>
    </DxDataGrid>
    <DxPopup
        :ref="changePasswordPopupRefName"
        :drag-enabled="false"
        :show-title="true"
        @showing="onShowningChangePasswordPopup"
        title="Jelszóváltoztatás"
    >
      <div>
        <DxForm
            :ref="newPasswordFormRefName"
            :form-data.sync="passwordFormData"
        >
          <DxFormItem
                      caption="Jelszó"
              data-field="newPassword"
              editor-type="dxTextBox"
              :editorOptions="{ mode: 'password' }"
          >
            <DxRequiredRule />
          </DxFormItem>
          <DxFormItem caption="Jelszó megerősítés"
              data-field="confirmPassword"
              editor-type="dxTextBox"
              :editorOptions="{ mode: 'password' }"
          >
            <DxRequiredRule />
          </DxFormItem>
        </DxForm>
      </div>
      <DxPopupToolbarItem
          :options="newPasswordSaveButtonOptions"
          toolbar="bottom"
          location="after"
          widget="dxButton"
      />
      <DxPopupToolbarItem
          :options="newPasswordCancelButtonOptions"
          toolbar="bottom"
          location="after"
          widget="dxButton"
      />
    </DxPopup>
  </div>
</template>

<script>
import accountService from "../services/account.service";
import roleService from "../services/role.service";
import DxDataGrid, {
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  DxColumn,
  DxEditing,
  DxLookup,
  DxRequiredRule,
  DxPopup as DxDataGridEditPopup,
  DxPosition,
  DxForm as DxDatagridEditForm,
  DxButton,
  DxColumnFixing
} from "devextreme-vue/data-grid";
import DxTagBox from "devextreme-vue/tag-box";
import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
import CustomStore from "devextreme/data/custom_store";
import DxForm, {
  DxItem as DxFormItem,
  DxButtonItem,
  DxLabel
} from "devextreme-vue/form";
import notify from "devextreme/ui/notify";
import DxPopup, {
  DxToolbarItem as DxPopupToolbarItem
} from "devextreme-vue/popup";

export default {
  components: {
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    DxColumn,
    DxEditing,
    DxLookup,
    DxTagBox,
    DxRequiredRule,
    DxPopup,
    DxPosition,
    DxDatagridEditForm,
    DxFormItem,
    DxToolbar,
    DxToolbarItem,
    DxButton,
    DxButtonItem,
    DxLabel,
    DxDataGridEditPopup,
    DxForm,
    DxPopupToolbarItem,
    DxColumnFixing,
    DxDataGrid
  },
  data() {
    return {
      isNewRow: false,
      gridRefName: 'grid',
      newPasswordFormRefName: 'newPasswordForm',
      changePasswordPopupRefName: 'changePasswordPopup',
      passwordFormData: {
        userId: 0,
        newPassword: null,
        confirmPassword: null
      },
      users: new CustomStore({
        key: "id",
        load: () => accountService.getUsers(),
        insert: (values) => {
          // TODO Van-e DevExtreme-es megoldás arra, hogy ne postolja?
          values.confirmPassword = undefined; // Nem szükséges postolni a confirmPassword-öt
          return accountService.insertUser(values);
        },
        update: async (key, values) => {
          return accountService.updateUser({
            key: key,
            values: JSON.stringify(values)
          })
        },
        remove: key => accountService.removeUser(key)
      }),
      rolesLookup: [],
      closeButtonOptions: {
        icon: "close",
        onClick: () => {
          this.dataGrid.cancelEditData();
        }
      },
      changePasswordButtonOptions: {
        icon: "key",
        text: "Jelszóváltoztatás",
        onClick: () => {
          this.changePasswordPopup.show();
        }
      },
      newPasswordSaveButtonOptions: {
        text: "Mentés",
        onClick: () => {
          const validation = this.newPasswordForm.validate();
          if (validation.isValid) {
            this.changePasswordPopup.hide();
            notify("Új jelszó mentése!");
          }
          accountService.changePassword(this.passwordFormData);
        }
      },
      newPasswordCancelButtonOptions: {
        text: "Mégsem",
        onClick: () => {
          this.changePasswordPopup.hide();
        }
      },
    }
  },
  async created() {
    this.rolesLookup = await roleService.get();
  },
  computed: {
    dataGrid: function () {
      return (this.$refs[this.gridRefName]).instance;
    },
    newPasswordForm: function () {
      return (this.$refs[this.newPasswordFormRefName]).instance;
    },
    changePasswordPopup: function () {
      return (this.$refs[this.changePasswordPopupRefName]).instance;
    },
  },
  methods: {
    onShowningChangePasswordPopup() {
      this.initPasswordFields();
    },
    initPasswordFields() {
      this.newPasswordForm.resetValues();
    },
    onEditingStart() {
      this.isNewRow = false;
    },
    hasPermission(permissionValue) {
      return accountService.userHasPermission(permissionValue);
    },
    onEditorPreparing(e) {
      if (e.dataField === "id" && e.parentType === "dataRow") {
        this.passwordFormData.userId = e.value;
      }

      if (e.dataField === "roles" && e.parentType === "dataRow") {
        e.editorName = "dxTagBox"; // Changes the editor's type
        e.editorOptions.onValueChanged = function(args) {
          // Implement your logic here
          e.setValue(args.value); // Updates the cell value
        };
      }
    },
    onInitNewRow() {
      this.isNewRow = true;
    },

    customizeItem(item) {
      if (
          item.dataField === "newPassword" ||
          item.dataField === "confirmPassword"
      ) {
        if (!this.isNewRow) {
          item.visible = false;
        }
      }

      if (item.dataField === "id" || item.name === "changePasswordButton") {
        if (this.isNewRow) {
          item.visible = false;
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.about {
  text-align: center;
}

::v-deep .dx-datagrid-content .dx-datagrid-table .dx-row > td,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
  vertical-align: middle !important;
}
</style>
